import React, { useEffect, useState } from 'react'
import { Box, InputBase, IconButton } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
import { useHistory } from 'react-router-dom'
import { useStyles } from './SearchInput.styles'

interface SearchInputProps {
  redirectUrl: string
  placeholder?: string
  initialValue?: string
}

const SearchInput = ({
  redirectUrl,
  placeholder = 'Procurar',
  initialValue = ''
}: SearchInputProps) => {
  const classes = useStyles()
  const history = useHistory()
  const [value, setValue] = useState(initialValue)

  const handleSearch = () => {
    const trimmedValue = value.trim()
    if (!trimmedValue) return
    history.push(`${redirectUrl}?q=${encodeURIComponent(trimmedValue)}`)
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }

  const handleClear = () => {
    setValue('')
  }

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  return (
    <Box className={classes.container}>
      <SearchIcon className={classes.icon} onClick={handleSearch} />
      <InputBase
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className={classes.input}
      />
      {value.length > 0 && (
        <IconButton
          size="small"
          className={classes.clearButton}
          onClick={handleClear}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  )
}

export default SearchInput
